// Resource<T>: the "loading / success / failure" shape around a task<T>,
// as reactive state<T> a Component can render and Subscribe to — React's
// (commonly hand-rolled, or via a data-fetching library) loading-state
// pattern / Angular's resource() equivalent.
enum AsyncStatus { Loading, Success, Failure }

class Resource<T> {
  public state<AsyncStatus> Status;
  public state<T?> Data;
  public state<string?> Error;

  constructor(task<T> operation) {
    this.Status = state(AsyncStatus.Loading);
    this.Data = state(null);
    this.Error = state(null);
    this.Run(operation);
  }

  private async task Run(task<T> operation) {
    try {
      T result = await operation;
      this.Data.Value = result;
      this.Status.Value = AsyncStatus.Success;
    } catch (string message) {
      this.Error.Value = message;
      this.Status.Value = AsyncStatus.Failure;
    }
  }
}
